class ToggleService {
    constructor(info) {
        this.info = info;
        this.toggles = [];
    }
    registerToggle(toggle) {
        this.toggles.push(toggle);
    }
    get isOn() {
        let isOn = true;
        this.toggles.forEach((toggle) => {
            const isDisabled = toggle.isDisabled(this.info);
            isOn = isOn && !isDisabled;
        });
        return isOn;
    }
}

export { ToggleService };
//# sourceMappingURL=action-toggle-service.js.map
